export default {
  GRAY_1: '#f5f6fb',
  GRAY_2: '#e7e9f3',
  GRAY_3: '#1f2937',
  GRAY_4: '#E1EBF0',
  GRAY_5: '#94a3b8',
  GRAY_6: '#EEEEEE',
  GRAY_7: '#F7F7F7',
  GRAY_8: '#DDDDDD',
  GRAY_9: '#BBBBBB',
  GRAY_10: '#848484',
  GRAY_11: '#F0F0F4',
  GRAY_12: '#E3EBF0',
  GRAY_13: '#C8D7E2',
  GRAY_14: '#C5C5C5',
  GRAY_15: '#797979',
  GRAY_16: '#DEE6E9',
  GRAY_17: '#EBEBEB',

  RED_1: '#DD4534',
  RED_2: '#F598A4',
  RED_3: '#E24132',
  RED_4: '#D04232',
  RED_5: '#D04232',
  RED_6: '#CE1F0F',

  GREEN_1: '#16A651',
  GREEN_2: '#118B43',
  GREEN_3: '#0F9F36',
  GREEN_4: '#27C3C2',
  GREEN_5: '#00A651',
  GREEN_6: '#D6F1F1',
  GREEN_7: '#22A257',
  GREEN_8: '#8ad000',

  BLUE_1: '#4b4acb',
  BLUE_2: '#6c63ff',
  BLUE_3: '#3a39a8',
  BLUE_4: '#4b4acb',
  BLUE_5: '#003BC8',
  BLUE_6: '#00A2E7',
  BLUE_7: '#eef1ff',
  BLUE_8: '#436781',
  BLUE_9: '#4b4acb',
  BLUE_10: '#5382A6',
  BLUE_11: '#0099FF',
  BLUE_12: '#7b61ff',

  YELLOW_1: '#FFB60F',
  YELLOW_2: '#FC860E',
  YELLOW_3: '#f5ab02',

  ORANGE_1: '#F68521',
  ORANGE_2: '#fc8601',

  RED_OVERLAY_1: 'rgba(245, 152, 164, 0.2)',

  OVERLAY_1: 'rgba(255, 255, 255, 0.5)',
  OVERLAY_2: 'rgba(0, 0, 0, 0.5)',

  SHADOW_1: 'rgba(0, 0, 0, 0.1)',
  SHADOW_2: 'rgba(0, 0, 0, 0.16)',
  SHADOW_3: 'rgba(0, 0, 0, 0.3)',

  WHITE: '#FFF',

  TRANSPARENT: 'transparent',
}
